export default __webpack_public_path__ + "static/media/icon-2.098ca29c.png";